export class BackButton {
    constructor() {
        $('.js-back-button').on('click', () => window.history.back());
    }
}
